import React from 'react';
import { twMerge } from 'tailwind-merge';
import type { TagProps } from '@/design-system';
import {
  Avatar,
  ListingBaseCard,
  CardDateRow,
  CardHighlightBox,
  CardTagHeader,
  Tag,
  Text,
  Title,
} from '@/design-system';
import { PreventionCardLabel } from '@/design-system/components/Layout/PreventionCard/PreventionCardLabel';

export enum CardType {
  MANDATORY = 'mandatory',
  OFFER = 'offer',
}

export interface CardProps {
  className?: string;
  name?: string;
  image?: string;
  tag?: string;
  tagLevel?: TagProps['level'];
  title?: string; //@todo: might be merged with name in the future
  highlight?: string;
  dateLabel?: string;
  date?: string;
  cardType: CardType;
  label?: string;
  onClick?: () => void;
  to?: string;
}

export const PreventionCard: React.FC<CardProps> = ({
  className,
  name,
  image,
  tag,
  tagLevel,
  title,
  highlight,
  dateLabel,
  date,
  cardType,
  label,
  onClick,
  to,
}) => {
  const containerClasses = twMerge('pb-1.5', className);
  return (
    <ListingBaseCard to={to} onClick={onClick} className={containerClasses}>
      <div className="flex flex-col gap-2">
        {!!tag && (
          <CardTagHeader>
            <Tag level={tagLevel}>{tag}</Tag>
          </CardTagHeader>
        )}
        <div className="px-2">
          <Avatar image={image} size="m" text={name} />
        </div>
      </div>
      <Title size="s" className="line-clamp-2 min-h-ds-15 px-2">
        {title}
      </Title>
      <div className="px-2 self-stretch">
        <CardHighlightBox>
          <Text weight="semibold" className="opacity-80 line-clamp-2 overflow-hidden text-ellipsis">
            {highlight}
          </Text>
        </CardHighlightBox>
      </div>
      {(dateLabel ?? date) && <CardDateRow label={dateLabel ?? ''} value={date ?? ''} />}
      <PreventionCardLabel cardType={cardType} className="-mx-1.5">
        {label}
      </PreventionCardLabel>
    </ListingBaseCard>
  );
};
